export const JoinTheWaitlistSuccessBgIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 371 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1001_2711)">
        <rect
          x="1"
          y="1"
          width="369"
          height="49"
          rx="8"
          fill="url(#paint0_linear_1001_2711)"
        />
        <rect
          x="1"
          y="1"
          width="369"
          height="49"
          rx="8"
          fill="url(#paint1_linear_1001_2711)"
        />
        <rect
          x="1"
          y="1"
          width="369"
          height="49"
          rx="8"
          fill="url(#paint2_linear_1001_2711)"
          fillOpacity="0.2"
        />
        <rect
          x="1"
          y="1"
          width="369"
          height="49"
          rx="8"
          fill="url(#paint3_linear_1001_2711)"
          fillOpacity="0.2"
        />
        <g opacity="0.8" filter="url(#filter0_f_1001_2711)">
          <path
            d="M222.291 44.3329C284.002 73.3916 248.069 210.439 224.311 200.734C209.818 194.814 189.88 147.481 144.196 126.203C114.991 112.601 64.9561 120.619 32.7649 121.082C-49.7828 122.268 160.065 15.0319 222.291 44.3329Z"
            fill="#D8DCDE"
          />
        </g>
      </g>
      <rect
        x="0.75"
        y="0.75"
        width="369.5"
        height="49.5"
        rx="8.25"
        stroke="url(#paint4_linear_1001_2711)"
        strokeWidth="0.5"
      />
      <defs>
        <filter
          id="filter0_f_1001_2711"
          x="-10.2045"
          y="15.2596"
          width="290.727"
          height="209.966"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12"
            result="effect1_foregroundBlur_1001_2711"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1001_2711"
          x1="177.748"
          y1="1"
          x2="177.748"
          y2="50"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0108897" stopColor="#771EE9" />
          <stop offset="1" stopColor="#7425E3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1001_2711"
          x1="288.211"
          y1="25.5"
          x2="370"
          y2="25.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.177885" stopColor="#6606E0" stopOpacity="0" />
          <stop offset="1" stopColor="#4E03AC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1001_2711"
          x1="179.298"
          y1="25.5"
          x2="1"
          y2="25.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#070010" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1001_2711"
          x1="117.977"
          y1="12.6932"
          x2="281.554"
          y2="12.6932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7542F7" stopOpacity="0" />
          <stop offset="1" stopColor="#7542F7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1001_2711"
          x1="71.3763"
          y1="47.2159"
          x2="197.481"
          y2="-53.216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFCFC" stopOpacity="0" />
          <stop offset="0.423077" stopColor="white" />
          <stop offset="1" stopColor="#B185E7" />
        </linearGradient>
        <clipPath id="clip0_1001_2711">
          <rect x="1" y="1" width="369" height="49" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

JoinTheWaitlistSuccessBgIcon.displayName = "JoinTheWaitlistSuccessBgIcon";
